import { memo } from 'react';

import type { DropdownActionField, BaseTypeProps } from 'schemaBuilder/types';

import { TypeWrapper } from '../../ui';

import DropdownBody from './body';

export interface Props extends BaseTypeProps {
  field: DropdownActionField;
}

export const Dropdown = ({
  isDragging,
  field,
  path,
  dragElement,
  removeElement,
  typeSelectElement,
  fieldKeyElement,
  theme,
  readonly
}: Props) => {
  return (
    <TypeWrapper
      schemaField={field.schemaField}
      readonly={readonly}
      required={field.required}
      isDragging={isDragging}
      dragElement={dragElement}
      typeSelectElement={typeSelectElement}
      removeElement={removeElement}
      fieldKeyElement={fieldKeyElement}
      path={path}
      theme={theme}
    >
      <DropdownBody
        readonly={readonly}
        schemaField={field.schemaField}
        path={path}
      />
    </TypeWrapper>
  );
};

export default memo(Dropdown);
